import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-login-send-email',
  templateUrl: './login-send-email.component.html',
  styleUrls: ['./login-send-email.component.scss'],
})
export class LoginSendEmailComponent implements OnInit {
  tenant: string = '';
  merchant: string = '';
  constructor(
    private readonly router: Router,
    private merchantService: MerchantService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
    this.merchant = this.merchantService.getLoginMerchant(this.tenant);
  }

  goToLogin() {
    this.router.navigateByUrl(`${this.tenant}/login?m=${this.merchant}`);
  }
}
